//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SPage from "~/components/page/SPage.vue";
import Stepper from "~/components/zapis/Stepper.vue";
import ServiceModal from "~/components/service/ServiceModal.vue";
import {AppMixin, UserMixin} from "~/node_modules/sitis-nuxt/lib/mixins";
import ServiceSelection from "~/components/zapis/ServiceSelection.vue";
import SalonSelection from "~/components/zapis/SalonSelection.vue";
import SpecialistsSelection from "~/components/zapis/SpecialistsSelection.vue";
import Form from "~/components/zapis/Form.vue";
import CategoryPage from "../../catalog/_";

export default {
    name: 'Zapis',
    head() {
        const head = {
            title: this.service.seo_title,
            meta: [
                {
                    hid: "metadescription",
                    name: "description",
                    content: this.service.seo_description,
                },
                {name: "keywords", content: this.service.seo_keywords},
            ],
        };

        return head;
    },

    components: {
        SPage,
        Stepper,
        ServiceSelection,
        SalonSelection,
        SpecialistsSelection,
        Form,
        ServiceModal,
    },

    mixins: [AppMixin],

    async asyncData({$api, params, error}) {
        const {data: services} = await $api.agent.transport.get(
          "services?expand=stores,image"
        );
        const {data: salons} = await $api.agent.transport.get("stores");
        const {data: specialists} = await $api.agent.transport.get(
          "specialist?expand=stores"
        );
        const {data: service} = await $api.agent.transport
          .get(`services/${params?.slug || ""}`)
          .catch(() => {
              return {data: {error: true}};
          });
        if (service.error) {
            error({statusCode: 404});

            return null;
        }

        return {
            services,
            salons,
            specialists,

            service,
        };
    },

    data() {
        return {
            salons: [],
            specialists: [],

            form: {
                service: "",
                salon: "",
                specialist: "",
                address: "",
            },
            sendedForm: {},
            breadcrumbs: [
                {
                    title: "Главная",
                    path: "/",
                },
                {
                    title: "Запись на приём",
                    path: "/zapis",
                },
            ],

            readServiceSlug: "",
            hashSalon: "",

            stage: 0,
            permittedStage: 0,

            isAppointmentSended: false,
            openModal: false,
        };
    },

    watch: {
        "$route.query": function () {
            this.initForm();
        },
    },

    mounted() {
        let newForm = {...this.form};

        // Если салон выбран с главной страницы
        const salon = this.$route.hash?.split("#")?.[1] || "";
        if (Boolean(salon)) {
            newForm.salon = Number(salon);
            this.hashSalon = salon;
        }

        this.form = newForm;

        this.initForm();
    },

    computed: {
        isShowImg() {
            return process.env.isShowImgAppointment === 'true';
        },
        salonServices: function () {
            const hash = this.hashSalon;

            if (!hash) {
                return this.services;
            }

            return this.services.filter((t) =>
              Boolean(t.stores.find((t) => String(t.id) === hash))
            );
        },
        salonAddressHash: function () {
            return (
              this.salons.find((t) => String(t.id) === this.hashSalon)?.address || ""
            );
        },

        messageSuccessAppointment: function () {
            const form = {...this.form};
            const sendedForm = {...this.sendedForm};

            if (
              !form.service ||
              form.service === -1 ||
              !form.salon ||
              form.salon === -1 ||
              !form.specialist ||
              form.specialist === -1
            ) {
                return `В ближайшее время с вами свяжется наш менеджер, чтобы подтвердить информацию и назначить удобное время посещения нашего специалиста`;
            }

            const specialistName = this.specialists.find(
              (t) => t.id === sendedForm.specialist_id
            )?.name;
            const serviceName = this.services.find(
              (t) => t.id === sendedForm.service_id
            )?.name;
            const salon = this.salons.find((t) => t.id === sendedForm.store_id);
            const dateFormat = (sendedForm.date || "").split("-").reverse().join(".");
            const beginFormat = (sendedForm.begin || "")
              .split(":")
              .splice(0, 2)
              .join(":");
            const endFormat = (sendedForm.end || "")
              .split(":")
              .splice(0, 2)
              .join(":");

            return `
      Вы записаны на прием в салон "Очки для Вас"!</br>
      Услуга: <span class="text-primary">${serviceName}</span></br>
      Специалист: <span class="text-primary">${specialistName}</span></br>
      Дата, время: <span class="text-primary">${dateFormat} ${beginFormat}</span></br>
      Адрес: <span class="text-primary">${salon?.address || ""}</span></br>
      Рады будем вас видеть!
      `;
        },

        servicePrice: function () {
            if (!this.service.price || this.service.price === 0) {
                return "бесплатно";
            }

            return `${this.service.price} ₽`;
        },
        serviceDuration: function () {
            const duration = this.service.duration;

            const hours = Math.floor(duration / 60);
            const minuts = duration - hours * 60;

            return [
                !!hours
                  ? `${hours} ${this.$caseWords(hours, ["час", "часа", "часов"])}`
                  : undefined,
                !!minuts
                  ? `${minuts} ${this.$caseWords(minuts, [
                      "минута",
                      "минуты",
                      "минут",
                  ])}`
                  : undefined,
            ].join(" ");
        },
        servicePrepare: function () {
          return this.service?.service_prepare || ''
        },

        // Допустимые возратные записи
        getAgeService: function () {
            let ages = [];

            if (this.service.for_children_2_6) {
                ages.push({label: "от 2 до 6 лет", value: "2-6"});
            }
            if (this.service.for_children_7_11) {
                ages.push({label: "от 7 до 11 лет", value: "7-11"});
            }
            if (this.service.for_children_12_18) {
                ages.push({label: "от 12 до 18 лет", value: "12-18"});
            }
            if (
              !this.service.for_children_12_18 &&
              !this.service.for_children_12_18 &&
              !this.service.for_children_2_6
            ) {
                ages.push({label: "старше 18 лет", value: "19"});
            }

            return ages;
        },
    },

    methods: {


        initForm: function () {
            let urlSearch = (window.location.search || "").substr(1).split("&");
            let replaceSearch = [];
            let step = 0;
            let permittedStage = 0;
            let newForm = {
                service: "",
                salon: Boolean(this.hashSalon) ? Number(this.hashSalon) : "",
                specialist: "",
                address: "",
            };

            // Проверяем, коректно ли заполнены данные
            urlSearch.map((item, idx) => {
                if (idx === 0 && item.indexOf("step_service") > -1) {
                    step = 1;
                    permittedStage = 1;
                    newForm.service = +(item || "").split("=")[1];

                    replaceSearch.push(item);
                }
                if (idx === 1 && item.indexOf("step_store") > -1) {
                    step = 2;
                    permittedStage = 2;
                    newForm.salon = +(item || "").split("=")[1];

                    replaceSearch.push(item);
                }
                if (idx === 2 && item.indexOf("step_specialist") > -1) {
                    step = 3;
                    permittedStage = 3;
                    newForm.specialist = +(item || "").split("=")[1];

                    replaceSearch.push(item);
                }
            });

            this.stage = step;
            this.form = newForm;
            this.permittedStage = permittedStage;

            window.history.replaceState(
              null,
              null,
              `${this.$route.path}?${replaceSearch.join("&")}`
            );
        },

        changeForm({name, value}, nextStage = null) {
            const newForm = {...this.form};
            newForm[name] = value;
            this.form = newForm;

            this.updateUrl();

            this.nextStage();
        },
        changeStage(stage) {
            this.stage = stage;
            this.permittedStage = stage;

            if (this.stage == 0) {
                this.form = {};
            }
            if (this.stage == 1) {
                this.form.specialist = "";
                this.form.salon = "";
            }
            if (this.stage == 2) {
                this.form.specialist = "";
            }

            this.updateUrl();
        },

        nextStage() {
            let stage = 0;

            if (this.form.service) {
                stage = 1;
            }
            if (this.form.salon) {
                stage = 2;
            }
            if (this.form.specialist) {
                stage = 3;
            }

            this.stage = stage;
            this.permittedStage = stage;
        },
        updateUrl() {
            const routePath = this.$route.path;
            let urlSearch = [];

            if (this.form.service) {
                urlSearch.push(`step_service=${this.form.service}`);
            }
            if (this.form.salon) {
                urlSearch.push(`step_store=${this.form.salon}`);
            }
            if (this.form.specialist) {
                urlSearch.push(`step_specialist=${this.form.specialist}`);
            }

            urlSearch = urlSearch.join("&");

            this.$router.push(`${routePath}?${urlSearch}`);
        },

        onZapis: function (age) {
            this.$router.replace(
              `/zapis?step_age=${age.value}&step_service=${this.service.id}`
            );
        },

        onOpenServiceModal: function (slug) {
            this.readServiceSlug = slug;

            // Замена URL при открии стать
            window.history.replaceState(null, null, `/zapis/${slug}`);
        },
        onCloseServiceModal: function () {
            this.$router.replace("/zapis");
        },

        successSendedForm: function (props) {
            this.sendedForm = props;
            this.isAppointmentSended = true;
        },
    },
};
